import React, { useState } from "react";

function CollapsibleTable({ team, players, selectedPlayers = [], onSelectPlayer, onSelectTeam }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [playerNotes, setPlayerNotes] = useState({}); // State to store notes for each player

  // Filter players by team
  const teamPlayers = players
    .filter((player) => player.TeamName === team)
    .sort((a, b) => a.JerseyNumber - b.JerseyNumber);

  const teamXIDs = teamPlayers.map((p) => p.PlayerXID).filter(Boolean);
  const allSelected =
    teamXIDs.length > 0 && teamXIDs.every((xid) => selectedPlayers.includes(xid));
  const someSelected =
    !allSelected && teamXIDs.some((xid) => selectedPlayers.includes(xid));

  // Handle opening the notes input
  const handleAddNote = (playerID) => {
    const note = prompt("Enter notes for this player:", playerNotes[playerID] || "");
    if (note !== null) {
      setPlayerNotes((prev) => ({
        ...prev,
        [playerID]: note,
      }));
    }
  };

  return (
    <div className="collapsible-table">
      <div className="table-header">
        {/* Team-level select-all checkbox — stop propagation so it doesn't collapse */}
        <input
          type="checkbox"
          className="team-select-checkbox"
          checked={allSelected}
          ref={(el) => {
            if (el) el.indeterminate = someSelected;
          }}
          onChange={(e) => onSelectTeam && onSelectTeam(teamXIDs, e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          title="Select all players on this team"
        />
        <h3 onClick={() => setIsCollapsed(!isCollapsed)} style={{ flex: 1, cursor: "pointer", margin: 0 }}>
          {team}
        </h3>
        <div
          className={`collapse-icon ${isCollapsed ? "collapsed" : ""}`}
          onClick={() => setIsCollapsed(!isCollapsed)}
        />
      </div>
      {!isCollapsed && (
        <table>
          <thead>
            <tr>
              <th>Select</th>
              <th>#</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Position</th>
              <th>Division</th>
              <th>First Choice</th>
              <th>Second Choice</th>
              <th>Third Choice</th>
              <th>Coaches Choice</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {teamPlayers.length > 0 ? (
              teamPlayers.map((player, index) => (
                <tr
                  key={index}
                  className={selectedPlayers.includes(player.PlayerXID) ? "row-selected" : ""}
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedPlayers.includes(player.PlayerXID)}
                      onChange={() => onSelectPlayer && onSelectPlayer(player.PlayerXID)}
                    />
                  </td>
                  <td>{player.JerseyNumber}</td>
                  <td>{player.LegalFirstName}</td>
                  <td>{player.LastName}</td>
                  <td>{player.PositionName}</td>
                  <td>{player.DivisionName}</td>
                  <td>{player.FirstChoiceVotes}</td>
                  <td>{player.SecondChoiceVotes}</td>
                  <td>{player.ThirdChoiceVotes}</td>
                  <td>{player.CoachVotes}</td>
                  <td>
                    <button
                      className={`note-button ${playerNotes[player.PlayerXID] ? "has-note" : ""}`}
                      onClick={() => handleAddNote(player.PlayerXID)}
                    >
                      📝
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  No players available for this team.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default CollapsibleTable;